import React from "react";
import Spinner from "react-spinkit";
import "../styles/components/loading-page.css";

const Loading = () => (
  <div className="loading">
    <Spinner className="loading-indicator" name="line-scale" color="white" />
  </div>
);

export default Loading;
